import React from "react";

// Suy màu + nhãn ruy băng theo đuôi file.
const getFileMeta = (fileType?: string): { color: string; label: string } => {
  const ft = (fileType || "").toLowerCase();
  if (ft.includes("pdf")) return { color: "#F1533E", label: "PDF" };
  if (ft.includes("xls") || ft.includes("csv"))
    return { color: "#81BC56", label: "XLS" };
  return { color: "#64748B", label: (fileType || "FILE").toUpperCase().slice(0, 3) };
};

// Icon file (document + ruy băng màu) — PDF đỏ, XLS xanh lá — khớp design.
const FileBadge: React.FC<{ fileType?: string; size?: number }> = ({
  fileType,
  size = 34,
}) => {
  const { color, label } = getFileMeta(fileType);
  const h = (size / 34) * 40;
  return (
    <svg width={size} height={h} viewBox="0 0 34 40" fill="none">
      <path
        d="M4 2 h18 l8 8 v26 a2 2 0 0 1 -2 2 H4 a2 2 0 0 1 -2 -2 V4 a2 2 0 0 1 2 -2 z"
        fill="#fff"
        stroke="#E1E4EA"
        strokeWidth={1.5}
      />
      <path d="M22 2 v8 h8" fill="none" stroke="#E1E4EA" strokeWidth={1.5} />
      <rect x={0} y={20} width={24} height={13} rx={2} fill={color} />
      <text
        x={12}
        y={29.5}
        textAnchor="middle"
        fontSize={8}
        fontWeight={700}
        fill="#fff"
      >
        {label}
      </text>
    </svg>
  );
};

export default FileBadge;
